import {
  EmailAuthProvider,
  RecaptchaVerifier,
  fetchSignInMethodsForEmail,
  linkWithCredential,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPhoneNumber,
} from "firebase/auth";
import { auth, db } from "../config/firebase";
import {
  serverTimestamp,
  doc,
  getDoc,
  setDoc,
  collection,
  getDocs,
} from "@firebase/firestore";
import { coursesList, userState } from "../store/slices/loginSlice";
import { serializeDate } from "../utils/utils";
import store from "../store/store";

export const setUpRecaptcha = async (phoneNumber, email) => {
  const signInMethods = await fetchSignInMethodsForEmail(auth, email);
  if (signInMethods && signInMethods.length > 0) {
    // eslint-disable-next-line no-throw-literal
    throw { code: "auth/email-already-in-use" };
  }

  return new RecaptchaVerifier(auth, "sign-in-button", {
    size: "invisible",
  });
};
export const createaAccountWithPhoneNumber = (phoneNumber, appVerifier) => {
  return signInWithPhoneNumber(auth, phoneNumber, appVerifier);
};

export const signUp = async (otp, confirmObj, email, password) => {
  const userInfo = store.getState().login.user;
  const result = await confirmObj.confirm(otp);
  const { emailVerified, uid, phoneNumber, photoURL } = result.user;
  const existingUser = await getDoc(doc(db, "users", uid));
  if (existingUser.exists()) {
    const logedInUser = await store.getUser(result.user.uid);
    store.dispatch(userState({ ...logedInUser, uid: result.user.uid }));
  }
  await setDoc(doc(db, "users", uid), {
    ...userInfo,
    email,
    emailVerified,
    phoneNumber,
    photoURL,
    createdAt: serverTimestamp(),
  });
  const credential = EmailAuthProvider.credential(email, password);
  linkWithCredential(result.user, credential).catch(async (error) => {
    if (error.code === "auth/provider-already-linked") {
    }
  });
};

export const verifyEmail = async () => {
  await sendEmailVerification(auth.currentUser, {
    url: "https://dev-follow-me-academy-student.web.app/",
  });
};

export const logIn = async (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const signOut = () => {
  store.dispatch(userState({}));
  auth.signOut();
};

export const resetPassword = (email) => {
  return sendPasswordResetEmail(auth, email);
};

export const getUser = async (userID) => {
  const docSnap = await getDoc(doc(db, "users", userID));
  if (docSnap.exists()) {
    return {
      ...docSnap.data(),
      createdAt: serializeDate(docSnap.data().createdAt),
    };
  }
};
export const updateUser = async (userID, emailVerified, email) => {
  await setDoc(
    doc(db, "users", userID),
    { emailVerified, email },
    {
      merge: true,
    }
  );
};
export const getCourses = async () => {
  const querySnapshot = await getDocs(collection(db, "courses"));

  const courses = [];
  querySnapshot.forEach((doc) => {
    courses.push({
      id: doc.id,
      courseName: doc.data().name,
      label: doc.data().label,
    });
  });

  store.dispatch(coursesList(courses));
};
